module.exports = __webpack_public_path__ + "static/media/chain-link.240a81d2.svg";